module.exports = function() {
  return new Worker(__webpack_public_path__ + "e87e7cc6706fe3a5442f.worker.js");
};